import { domain } from "../auth/domain";

const handleResponse = async (response) => {
  if (!response.ok) {
    const error = await response.json();
    // Create a more detailed error message for the user from backend validation
    const errorMessages = Object.entries(error)
      .map(([key, value]) => {
        const formattedKey = key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
        const message = Array.isArray(value) ? value.join(', ') : value;
        return `${formattedKey}: ${message}`;
      })
      .join('; ');
    throw new Error(errorMessages || `Request failed with status: ${response.status}`);
  }
  return response.json();
};

/**
 * Creates authorization headers for API requests.
 * @returns {Object} The headers object with the JWT token.
 */
const getAuthHeaders = () => {
  const token = localStorage.getItem("accessToken");
  return {
    "Content-Type": "application/json",
    Authorization: `JWT ${token}`,
  };
};

/**
 * Fetches all arrears invoices for the user's group.
 * @returns {Promise<Array>} A promise that resolves to an array of invoices.
 */
export const fetchArrearsInvoices = async () => {
  const headers = getAuthHeaders();
  const response = await fetch(`${domain}contributions/arrears-invoices/`, { headers });

  return handleResponse(response);
};

/**
 * Calls the backend to generate a new arrears invoice for a specific member.
 * @param {string} memberId - The ID of the member to generate an invoice for.
 * @returns {Promise<Object>} A promise that resolves to the newly created invoice object.
 */
export const generateArrearsInvoice = async (memberId) => {
  const headers = getAuthHeaders();
  const response = await fetch(`${domain}contributions/members/${memberId}/generate-arrears-invoice/`, {
    method: "POST",
    headers,
  });

  return handleResponse(response);
};


/**
 * Fetches the currently logged-in member's single pending arrears invoice.
 * @returns {Promise<Object|null>} A promise that resolves to the invoice object or null if not found.
 */
export const fetchMyArrearsInvoice = async () => {
  const headers = getAuthHeaders();
  const response = await fetch(`${domain}contributions/my-arrears-invoice/`, { headers });

  // If the backend returns a 404 (Not Found), we handle it gracefully by returning null.
  if (response.status === 404) return null;

  return handleResponse(response);
};